import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(() => SelectAtomSharedComponent),
    multi: true
};

import { ISelect } from './select.interface';
import { IErrors } from '../../molecules/input/errors.interface';

@Component({
    selector: 'mlp-ng-select-atom',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    providers: [ CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR ]
})

export class SelectAtomSharedComponent implements ControlValueAccessor {
    @Input() options: Array<ISelect> = [];
    @Input() disable = false;
    @Input() errors: Array<IErrors> = [];
    @Input() shadow = false;
    selectedValue: any;

    // tslint:disable-next-line:no-input-rename
    @Input('value') _value: any;

    constructor(private ref: ChangeDetectorRef) {}

    get value(): any {
        return this._value;
    }

    set value(val) {
        this.selectedValue = val;
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    writeValue(value): void {
        if (typeof value !== 'undefined') {
            this.value = value;
        }

        if (typeof value === 'undefined') {
            this.value = '';
        }

        this.ref.markForCheck();
        this.switched();
    }

    customCompare(o1: any, o2: any): boolean {
        if (o1 && typeof o1 === 'object' && (JSON.stringify(o1) === JSON.stringify(o2))) return true;

        return o1 === o2;
    }

    onChange: any = () => {};
    onTouched: any = () => {};
    registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
    registerOnTouched(fn: () => void): void { this.onTouched = fn; }

    switched(): void {
        this.value = this.selectedValue;
    }
}
